import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getFilterDateString } from 'utils/formatting'

// Actions
export const CREATE_GROUP_BUTTON_CLICK = 'Manage Traps :: Create a Group :: Button click'
export const CREATE_GROUP_SUCCESS = 'Manage Traps :: Group Created'
export const EXPORT_DATA_BUTTON_CLICK = 'Trap data :: Export data :: Button click'
export const EXPORT_DATA_GROUP_REPORT = 'Export data :: Group summary :: Report generated'
export const EXPORT_DATA_TRAP_REPORT = 'Export data :: Trap data :: Report generated'
export const INVITE_ADMIN_SUCCESS = 'Settings :: Admin invite sent'
export const INVITE_CODE_CREATED = 'People :: Invite code generated'
export const TRAP_DATA_HEATMAP_ON = 'Trap data :: Heat map :: Button click'
export const TRAP_DELETED = 'Manage traps :: Trap deleted'
export const GROUP_DELETED = 'Manage traps :: Groups :: Group deleted'
export const PEOPLE_DELETED = 'People :: Contributor removed'
export const GROUP_DATA_FILTER = filter => `Trap data :: Groups filter :: ${getFilterDateString(filter)} selected`
export const TRAP_DATA_FILTER = filter => `Trap data :: Traps filter :: ${getFilterDateString(filter)} selected`

// Page views
export const SCREEN_VIEW_PROFILE = 'Profile :: Screen views'
export const SCREEN_VIEW_CREATE_ORGANISATION = 'Create organisation :: Screen views'
export const SCREEN_VIEW_EDIT_PROFILE = 'Edit profile :: Screen views'
export const SCREEN_VIEW_CHANGE_PASSWORD = 'Change password :: Screen views'
export const SCREEN_VIEW_ORGANISATION_OVERVIEW = 'Organisation overview :: Screen views'
export const SCREEN_VIEW_TRAP_DATA_GROUPS = 'Trap data - Groups :: Screen views'
export const SCREEN_VIEW_TRAP_DATA_TRAPS = 'Trap data - Traps :: Screen views'
export const SCREEN_VIEW_MANAGE_TRAPS_GROUPS = 'Manage traps - Groups :: Screen views'
export const SCREEN_VIEW_MANAGE_TRAPS_TRAPS = 'Manage traps - Traps :: Screen views'
export const SCREEN_VIEW_GROUP_TRAPS = 'Trap group - Traps :: Screen views'
export const SCREEN_VIEW_GROUP_VIEWERS = 'Trap group - Viewers :: Screen views'
export const SCREEN_VIEW_PEOPLE_ALL = 'People - All :: Screen views'
export const SCREEN_VIEW_PEOPLE_REQUESTS = 'People - Requests :: Screen views'
export const SCREEN_VIEW_SETTINGS_ADMINISTRATION = 'Settings - Administration :: Screen views'
export const SCREEN_VIEW_SETTINGS_ORGANISATION = 'Settings - Organisation :: Screen views'

export default (WrappedComponent) => {
  class WithMixpanel extends Component {
    static displayName = `WithMixpanel(${WrappedComponent.displayName ||
      'Component'})`

    static contextTypes = {
      mixpanel: PropTypes.object.isRequired,
    }

    track = (...args) => {
      this.context.mixpanel.track(...args)
    }

    render() {
      return <WrappedComponent track={this.track} {...this.props} />
    }
  }

  return WithMixpanel
}



// WEBPACK FOOTER //
// ./src/utils/mixpanel.js